type Context = 'signals';

type Section = 'filters' | 'filter-options';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  filters: 'signals-filters',
  'filter-options': 'signals-filter-options',
};
